export interface JwtPayload {
  sub?: string;
  email?: string;
  iat?: number;
  exp?: number;
  [key: string]: unknown;
}

export const parseJwt = (token: string): JwtPayload | null => {
  const base64Url = token.split('.')[1];
  if (base64Url === undefined) {
    return null;
  }

  try {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );
    const payload: unknown = JSON.parse(jsonPayload);

    return typeof payload === 'object' && payload !== null ? payload : null;
  } catch {
    return null;
  }
};
